<template>
  <b-modal
    id="modal-editar-dia-cobranca"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    size="md"
    title="Alterar Dia de Cobrança"
  >
    <b-form>
      <b-form-group label="Dia de Cobrança" label-for="dia-cobranca-select">
        <b-form-select
          id="dia-cobranca-select"
          v-model="dia"
          :options="dias"
        />
      </b-form-group>

      <b-form-group>
        <b-row>
          <b-col>
            <b-button
              block
              variant="gradient-success"
              @click="gravar"
              :disabled="submit"
            >
              <b-spinner
                v-if="submit"
                small
                type="grow"
                class="mr-2"
              /> Gravar
            </b-button>
          </b-col>
          <b-col>
            <b-button
              block
              :disabled="submit"
              variant="secondary"
              @click="$bvModal.hide('modal-editar-dia-cobranca')"
            >
              Fechar
            </b-button>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BSpinner,
    BFormSelect,
    BFormGroup,
    BForm,
    BModal,
    BButton,
    BRow,
    BCol,
  },
  props: ["editarItem"],

  data() {
    return {
      submit: false,
      dia: 1,
      dias: Array.from({ length: 30 }, (_, i) => ({
        value: i + 1,
        text: `${i + 1}`,
      })),
    };
  },

  watch: {
    editarItem: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.dia_cobranca) {
          const diaStr = String(newVal.dia_cobranca);
          let diaNum;
          if (diaStr.includes("-")) {
            const parts = diaStr.split("-");
            diaNum = parseInt(parts[2], 10);
          } else {
            diaNum = parseInt(diaStr, 10);
          }
          if (diaNum >= 1 && diaNum <= 30) {
            this.dia = diaNum;
          } else {
            this.dia = 1;
          }
        } else {
          this.dia = 1;
        }
      },
    },
  },

  methods: {
    gravar() {
      if (!this.dia || this.dia < 1 || this.dia > 30) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Validação",
            text: "Selecione um dia entre 1 e 30.",
            variant: "warning",
          },
        });
        return;
      }

      this.submit = true;

      const params = {
        dia: this.dia,
      };

      this.$http
        .put(
          `adm/administracao/clientes/dia-cobranca/${this.editarItem.id_company}`,
          params
        )
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Dia de Cobrança",
              text: "Dia de Cobrança alterado com sucesso!",
              variant: "success",
              icon: "AlertIcon",
            },
          });

          this.$bvModal.hide("modal-editar-dia-cobranca");
          this.$emit("atualizar");
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Dia de Cobrança",
              text:
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : "Ocorreu um erro ao alterar o dia de cobrança.",
              variant: "danger",
              icon: "AlertIcon",
            },
          });
        })
        .finally(() => {
          this.submit = false;
        });
    },
  },
};
</script>

<style>
</style>
